export * from './vec3'
export * from './quat'
export * from './mat4'
export * from './pose'

export const DEG2RAD = Math.PI / 180
export const RAD2DEG = 180 / Math.PI
export const clamp = (v: number, lo: number, hi: number): number => (v < lo ? lo : v > hi ? hi : v)
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t
